import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import $ from "jquery";
import "datatables.net";
import ToastService from "../../services/ToastService";
import LeadsAssignedService from "../../services/LeadsAssignedService";
import RegisterUserService from "../../services/RegisterUserService";
import AuthService from "../../services/AuthService";
import { FaClock } from "react-icons/fa";
import { LEAD_STATUSES, PROPERTY_TYPES } from "../../constants/leadConstants";
const API_URL = process.env.REACT_APP_API_URL;

const unwrapJsonArray = (val) => {
  if (val == null) return [];
  if (Array.isArray(val)) return val;
  if (Array.isArray(val.$values)) return val.$values;
  return [];
};

const normalizeLead = (l) => {
  if (!l || typeof l !== "object") return l;
  return {
    id: l.id ?? l.Id,
    leadCode: l.leadCode ?? l.LeadCode,
    firstName: l.firstName ?? l.FirstName,
    lastName: l.lastName ?? l.LastName,
    email: l.email ?? l.Email,
    contactNumber: l.contactNumber ?? l.ContactNumber,
    source: l.source ?? l.Source,
    property: l.property ?? l.Property,
  };
};

const normalizeUser = (u) => {
  if (!u || typeof u !== "object") return u;
  return {
    id: u.id ?? u.Id,
    firstName: u.firstName ?? u.FirstName,
    lastName: u.lastName ?? u.LastName,
    email: u.email ?? u.Email,
  };
};

const normalizeLeadStatus = (ls) => {
  if (!ls || typeof ls !== "object") return ls;
  return {
    id: ls.id ?? ls.Id,
    leadStatusName: ls.leadStatusName ?? ls.LeadStatusName,
  };
};

const normalizePendingRow = (row) => {
  if (!row || typeof row !== "object") return row;
  const rawLead = row.lead ?? row.Lead;
  const rawUser = row.user ?? row.User;
  const rawStatus = row.leadStatus ?? row.LeadStatus;
  return {
    id: row.id ?? row.Id,
    leadId: row.leadId ?? row.LeadId,
    leadStatusId: row.leadStatusId ?? row.LeadStatusId,
    userId: row.userId ?? row.UserId,
    conversationComment: row.conversationComment ?? row.ConversationComment,
    leadAssignedDate: row.leadAssignedDate ?? row.LeadAssignedDate,
    followUpDate: row.followUpDate ?? row.FollowUpDate,
    nextUpdate: row.nextUpdate ?? row.NextUpdate,
    lead: rawLead ? normalizeLead(rawLead) : null,
    user: rawUser ? normalizeUser(rawUser) : null,
    leadStatus: rawStatus ? normalizeLeadStatus(rawStatus) : null,
  };
};

const PF_PALETTE = [
  "linear-gradient(135deg,#6366f1,#4f46e5)",
  "linear-gradient(135deg,#06b6d4,#0891b2)",
  "linear-gradient(135deg,#22c55e,#15803d)",
  "linear-gradient(135deg,#f59e0b,#d97706)",
  "linear-gradient(135deg,#ec4899,#be185d)",
  "linear-gradient(135deg,#8b5cf6,#6d28d9)",
];
const escHtml = (s) =>
  String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
const initLetter = (name = "") => (String(name).trim()[0] || "?").toUpperCase();
const pickColor = (seed = "") => {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return PF_PALETTE[h % PF_PALETTE.length];
};
const fmtDate = (raw) => {
  if (!raw) return "—";
  const d = new Date(raw);
  return isNaN(d.getTime()) ? "—" : d.toLocaleDateString();
};

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function PendingFollowUps() {
  const [pendingFollowups, setPendingFollowups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const toast = useRef(null);
  const toastService = new ToastService(toast);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const navigate = useNavigate();
  const [searchTerm] = useState("");
  const tableRef = useRef(null);
  const [employees, setselectedUser] = useState([]);
  const queryParam = useQuery();
  const [UserId] = useState(() => AuthService.resolveScopedUserId(queryParam.get("id")));
  const [LeadsAssigned, setLeadsAssigned] = useState([]);
  const savedPageNumber = localStorage.getItem("currentPageNumber")
    ? parseInt(localStorage.getItem("currentPageNumber"))
    : 1;
  const [pageNumber, setPageNumber] = useState(savedPageNumber);
  const pageSize = 10;
  const ClientId = AuthService.getLoggedInClientId();
  const [recordsTotal, setRecordsTotal] = useState(0);
  const [recordsFiltered, setRecordsFiltered] = useState(0);

  useEffect(() => {
    const token = AuthService.getToken();
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      displayStart: (savedPageNumber - 1) * pageSize,
      ajax: function (data, callback, settings) {
        const currentPage = Math.floor(data.start / data.length) + 1;
        localStorage.setItem("currentPageNumber", currentPage);
        setPageNumber(currentPage); // optional: in case you use it in UI
        const url = `${API_URL}/LeadAssigned/GetPendingFollowupList/${UserId}/${ClientId}/${currentPage}/${pageSize}`;
        $.ajax({
          url,
          type: "POST",
          dataType: "json",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          success: function (response) {
            const envelope = response.value ?? response;
            const rawPayload = envelope.data ?? envelope.Data;
            const dataArr = unwrapJsonArray(rawPayload).map(normalizePendingRow);
            callback({
              draw: parseInt(data.draw, 10),
              recordsTotal: envelope.recordsTotal ?? envelope.RecordsTotal ?? 0,
              recordsFiltered: envelope.recordsFiltered ?? envelope.RecordsFiltered ?? 0,
              data: dataArr,
            });
          },
          error: function (xhr, error, code) {
            console.error("API Request failed:", error, xhr);
            toastService.showError("Error", "Failed to fetch leads data");
          },
        });
      },
      columnDefs: [{ targets: [0], visible: true, searchable: false }],
      columns: [
        {
          data: "conversationComment",
          name: "Conversation Comment",
          autoWidth: true,
          render: function (data) {
            const safe = escHtml(data || "—");
            return `<span class="comment-cell" title="${safe}">${safe}</span>`;
          },
        },
        {
          data: null,
          name: "Lead Code",
          autoWidth: true,
          render: function (data, type, row) {
            const code = row.lead ? row.lead.leadCode : "—";
            return `<span class="lead-code-pill">${escHtml(code)}</span>`;
          },
        },
        {
          data: null,
          name: "First Name",
          autoWidth: true,
          render: function (data, type, row) {
            const name = row.lead ? row.lead.firstName : "Unknown";
            const seed = `${row.lead?.firstName || ""}${row.lead?.email || ""}`;
            return `
              <div class="user-cell">
                <span class="user-avatar" style="background:${pickColor(seed)}">${escHtml(initLetter(name))}</span>
                <span class="user-cell-meta"><span class="user-cell-name">${escHtml(name)}</span></span>
              </div>`;
          },
        },
        {
          data: null,
          name: "Contact Number",
          autoWidth: true,
          render: function (data, type, row) {
            const phone = row.lead?.contactNumber;
            if (!phone) return `<span class="cell-muted">—</span>`;
            const safe = escHtml(phone);
            return `<a href="tel:${safe}" class="cell-strong" style="text-decoration:none;color:var(--app-primary-700)">${safe}</a>`;
          },
        },
        {
          data: null,
          name: "Source",
          autoWidth: true,
          render: function (data, type, row) {
            const src = (row.lead?.source || "").toLowerCase();
            if (src === "fb")
              return `<span class="source-chip fb" title="Facebook"><i class="fab fa-facebook-f"></i></span>`;
            if (src === "ig")
              return `<span class="source-chip ig" title="Instagram"><i class="fab fa-instagram"></i></span>`;
            return `<span class="cell-muted">—</span>`;
          },
        },
        {
          data: null,
          name: "Lead Status",
          autoWidth: true,
          render: function (data, type, row) {
            const statusName = row.leadStatus?.leadStatusName || "Unknown";
            return `<span class="lead-status status-default">${escHtml(statusName)}</span>`;
          },
        },
        {
          data: null,
          name: "Property",
          autoWidth: true,
          render: function (data, type, row) {
            const prop = row.lead?.property;
            if (!prop) return `<span class="cell-muted">—</span>`;
            const safe = escHtml(prop);
            return `<span class="property-pill" title="${safe}">${safe}</span>`;
          },
        },
        {
          data: "leadAssignedDate",
          name: "LeadAssigned Date",
          autoWidth: true,
          render: function (data) {
            return `<span class="date-chip">${escHtml(fmtDate(data))}</span>`;
          },
        },
        {
          data: null,
          name: "Employee Name",
          autoWidth: true,
          render: function (data, type, row) {
            const emp = row.user;
            if (!emp) return `<span class="cell-muted">—</span>`;
            const fullName =
              `${emp.firstName || ""} ${emp.lastName || ""}`.trim() ||
              "Employee";
            const seed = `${emp.firstName || ""}${emp.lastName || ""}${emp.email || ""}`;
            return `
              <div class="emp-cell">
                <span class="emp-avatar" style="background:${pickColor(seed)}">${escHtml(initLetter(emp.firstName))}</span>
                <span class="emp-name">${escHtml(fullName)}</span>
              </div>`;
          },
        },
        {
          data: "followUpDate",
          name: "followUpDate",
          autoWidth: true,
          render: function (data) {
            return `<span class="date-chip">${escHtml(fmtDate(data))}</span>`;
          },
        },
        {
          data: "nextUpdate",
          name: "Next Update",
          autoWidth: true,
          render: function (data) {
            return `<span class="date-chip">${escHtml(fmtDate(data))}</span>`;
          },
        },
        {
          data: null,
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `<button class="action-btn edit-lead-btn" data-id="${row.id}" title="Edit"><i class="pi pi-pencil"></i></button>`;
          },
        },
      ],
      drawCallback: function (settings) {
        //   const currentPage = Math.floor(settings._iDisplayStart / settings._iDisplayLength) + 1;
        //   if (currentPage !== pageNumber) {
        //     setPageNumber(currentPage);
        //     localStorage.setItem('currentPageNumber', currentPage);
        // }
      },
      stateSave: true,
      // infoCallback: function (settings, start, end, max, total, pre) {
      //   const pageStart = start || 0;
      //    const pageEnd = end || 0;
      //   const pageInfo = `${pageStart} to ${pageEnd} of ${recordsFiltered} entries (Total: ${recordsTotal})`;
      //   return pageInfo;
      // },
    });

    $(tableRef.current).on("click", ".edit-lead-btn", function () {
      const leadId = $(this).data("id");
      navigate(`/editleadassigned/${leadId}`);
    });

    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [UserId, ClientId]);

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const users = await RegisterUserService.getEmployessByRoleId(4);
        setselectedUser(users);
      } catch (error) {
        console.error("Error fetching users:", error);
        toastService.showError("Error", "Failed to fetch users data");
      }
    };

    fetchEmployee();
  }, [UserId]);

  useEffect(() => {
    if (Notification.permission === "default") {
      Notification.requestPermission();
    }
  }, []);

  const sourceTypes = [
    { id: 1, name: "Facebook" },
    { id: 2, name: "Instagram" },
    { id: 3, name: "Reference" },
  ];

  const PropertyType = [
    { id: 1, name: "1BHK" },
    { id: 2, name: "2BHK" },
    { id: 3, name: "3BHK" },
    { id: 4, name: "4BHK" },
    { id: 5, name: "5BHK" },
    { id: 6, name: "Plot" },
    { id: 7, name: "Kothi" },
    { id: 8, name: "Other" },
  ];

  const LeadStatus = LEAD_STATUSES;

  const filteredpendingFollowups = (pendingFollowups || []).filter(
    (pendingfollowups) => {
      const leadStatus = LeadStatus.find(
        (leadstatus) => leadstatus.id === pendingfollowups.leadStatusId,
      );
      const leadStatusName = leadStatus ? leadStatus.name : "Unknown";

      if (
        leadStatusName === "NotInterested" ||
        leadStatusName === "InvalidNumber"
      ) {
        return false;
      }

      return (
        pendingfollowups.conversationComment &&
        pendingfollowups.conversationComment
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );
    },
  );

  function getStatusClass(leadStatusName) {
    switch (leadStatusName) {
      case "Interested":
        return "badge badge-sm bg-gradient-success";
      case "HotClient":
        return "badge badge-sm bg-gradient-danger";
      case "NotInterested":
        return "badge badge-sm bg-gradient-secondary";
      case "CallBackLater":
        return "badge badge-sm bg-gradient-dark";
      case "InvalidNumber":
        return "badge badge-sm bg-gradient-light";
      case "Complete":
        return "badge badge-sm bg-gradient-secondary";
      case "Visited":
        return "badge badge-sm bg-gradient-primary";
      case "Upcoming Visit":
        return "badge badge-sm bg-gradient-warning";
      default:
        return "";
    }
  }

  const renderPendingFollowups = () => {
    if (!Array.isArray(filteredpendingFollowups)) return null;

    return filteredpendingFollowups.map((pending) => {
      const lead = pending.lead;

      const sourceType = lead
        ? sourceTypes.find((source) => source.id === lead.sourceTypeId)
        : null;
      const sourceTypeName = sourceType ? sourceType.name : "Unknown";

      const leadStatus = LeadStatus.find(
        (leadstatus) => leadstatus.id === pending.leadStatusId,
      );
      const leadStatusName = leadStatus ? leadStatus.name : "Unknown";

      const property = PropertyType.find(
        (propertytype) => propertytype.id === pending.propertyTypeId,
      );
      const propertyTypeName = property ? property.name : "Unknown";

      const employee = employees.find((emp) => emp.id === pending.userId);
      const employeeName = employee
        ? `${employee.firstName} ${employee.lastName}`
        : "InActive Employee";
      return (
        <tr key={pending.id}>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {pending.conversationComment}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {lead ? `${lead.leadCode}` : "Unknown Lead"}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {lead ? `${lead.firstName}` : "Unknown Lead"}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {lead ? `${lead.contactNumber}` : "Unknown Lead"}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {lead ? `${lead.source}` : "Unknown Lead"}
            </span>
          </td>
          <td class="align-middle text-center text-sm">
            <span class={getStatusClass(leadStatusName)}>
              {" "}
              {leadStatusName}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {propertyTypeName}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {lead ? `${lead.property}` : "Unknown Lead"}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {" "}
              {new Date(pending.leadAssignedDate).toLocaleDateString()}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {employeeName}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {new Date(pending.followUpDate).toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                hour12: true,
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {new Date(pending.nextUpdate).toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                hour12: true,
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </span>
          </td>
          <td class="align-middle">
            <button
              className="btn btn-outline-dark btn-sm"
              onClick={() => navigate(`/editleadassigned/${pending.id}`)}
            >
              <i className="pi pi-pencil" style={{ fontSize: "1.5rem" }}></i>
            </button>
          </td>
        </tr>
      );
    });
  };
  return (
    <div>
      <Toast ref={toast} />
      <div className="col-12">
        <div className="list-card my-2">
          <div className="list-card-header">
            <div className="list-card-title">
              <span className="list-card-icon">
                <FaClock />
              </span>
              <div>
                <h5>Pending Follow-Ups</h5>
                <p>Leads requiring follow-up action</p>
              </div>
            </div>
          </div>
          <div className="card-body px-0 pb-2 pt-0">
            <div className="table-responsive p-0">
              <table
                id="tableData"
                ref={tableRef}
                className="table align-items-center mb-0"
              >
                <thead>
                  <tr>
                    <th>Comments</th>
                    <th>Lead Code</th>
                    <th>Name</th>
                    <th>Contact</th>
                    <th className="text-center">Source</th>
                    <th>Status</th>
                    <th>Property</th>
                    <th>Assigned</th>
                    <th>Employee</th>
                    <th>Follow Up</th>
                    <th>Next</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PendingFollowUps;
